import { useState, useEffect } from 'react';

import { type Stripe, loadStripe } from '@stripe/stripe-js';

import { getStripeLocale } from '../checkout/helpers';
import { useCurrentLanguage } from '../language/useCurrentLanguage';
import { useCurrentLocation } from '../location/useCurrentLocation';

export function useLoadStripe(stripeKey?: string) {
  const { language } = useCurrentLanguage();
  const { location } = useCurrentLocation();
  const [stripe, setStripe] = useState<Promise<Stripe | null> | null>(null);
  const [hasErrored, setHasErrored] = useState<boolean>(false);

  useEffect(() => {
    if (stripeKey && !stripe) {
      setStripe(
        loadStripe(stripeKey, {
          locale: getStripeLocale(location, language),
        }).catch(() => {
          setHasErrored(true);
          return null;
        })
      );
    }
  }, [stripeKey]);

  return { stripe, hasErrored };
}
